import { FC } from 'react';
import TextLink from '../../../components/TextLink';

interface LinkWithTextProps {
  url: string;
  title: string;
  text: string;
}
const LinkWithText: FC<LinkWithTextProps> = ({ url, text, title }) => {
  return (
    <>
      <TextLink url={url} variant="secondary" external={true}>
        {title}
      </TextLink>
      <p className="text-sm text-ph-gray-white">{text}</p>
    </>
  );
};

export default LinkWithText;
